import { resolveExpandDestination } from "@repo/agent-chat";
import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";
import { useNavigate } from "@tanstack/react-router";
import { Maximize2Icon } from "lucide-react";
import { useAgentChatContext } from "./use-agent-chat-context";

/**
 * MIN-242: takes the conversation already open in the panel to the full-page
 * route. Reads the compound's resolved `activeThreadId` (not the store
 * directly) so this stays correct under `AgentChat.Root`'s controlled mode
 * (MIN-239/240) too — a controlled caller's `threadId` prop can differ from
 * whatever's stored, and the button must expand to the thread actually on
 * screen, not necessarily the stored one. Must leave the active thread
 * untouched: no create, switch, or delete.
 */
export function AgentChatExpandButton({ className }: { className?: string }) {
  const { state } = useAgentChatContext();
  const navigate = useNavigate();

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn("h-7 w-7 text-muted-foreground", className)}
      title="Expand to full page"
      onClick={() => navigate(resolveExpandDestination(state.activeThreadId))}
    >
      <Maximize2Icon className="h-4 w-4" />
    </Button>
  );
}
